import React, { Component } from "react";
import Button from "components/UI/Button";
import Box from "components/UI/Box";
import axios from "axios";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { alert } from '../../../../../common/Utils'
import { API_URL, ERROR_HANDLE, GYM_TAG_UNIQUE_ID } from "config/constants";
import GymList from '../../GymList';
import PromotionalPreview from '../Modals/PromotionalPreview'
import theme from '../../../../../Theme/theme'

const CREATE_TEXT = "Create"
const UPDATE_TEXT = "Update"
const PREVIEW_TEXT = "Preview"
const OFFER_NAME_TEXT = "Offer Name"
const PRODUCT_NAME_TEXT = "Product Name"
const TITLE_TEXT = "Title"
const DESCRIPTION_TEXT = "Description"
const POPUP_TIMING_TEXT = "POPUP TIMING"
const ALERT_TEXT = "Title, Description and Product name is mandatory. Please fill mandatory fields to preview"
const PROMOTIONAL_OFFERS = "Promotional Offers"
const INCREMENT_ARROW_IMAGE = require('../../../../../assets/images/increment-arrow.png');
const DECREMENT_ARROW_IMAGE = require('../../../../../assets/images/decrement-arrow.png');
const LEFT_ARROW_IMAGE = require('../../../../../assets/images/left-arrow-black.png');
const POPUP_TIME_DEFAULT = "EXACT"
const POPUP_TYPE_DEFAULT = "WORKOUTS";
const POPUP_TIME = {
    before: "BEFORE",
    exact: "AT EXACTLY",
    after: "AFTER"
}
const POPUP_TYPE = {
    workouts: "WORKOUTS",
    total_hours: "TOTAL HOURS"
}

class CreatePromotionalOffer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            promotionId: null,
            offerName: "",
            productName: "",
            title: "",
            description: "",
            popupThreshold: 1, //Default should be - Exact 1 workouts
            popupTime: POPUP_TIME_DEFAULT,
            popupType: POPUP_TYPE_DEFAULT,
            gymsList: [],
            gymsSelected: [],
            tagsSelected: [],
            showPreview: false
        };
    }

    componentDidMount() {
        if (this.props.location.state && this.props.location.state.promotionId) {
            this.getPromotionalOffer(this.props.location.state.promotionId)
        }
    }

    getPromotionalOffer(promotion_id) {
        const access_token = localStorage.getItem("access_token");
        const toastId = toast("Fetching Promotional Offer...");
        axios
            .get(`${API_URL}/promotional_offers/${promotion_id}`, {
                headers: {
                    "x-access-token": access_token
                }
            })
            .then(res => {
                toast.dismiss(toastId);
                const promotionalOffer = res.data;
                this.setState({
                    promotionId: promotionalOffer.promotion_id,
                    offerName: promotionalOffer.offer_name,
                    productName: promotionalOffer.product_name,
                    title: promotionalOffer.title,
                    description: promotionalOffer.description,
                    popupThreshold: promotionalOffer.popup_threshold ? parseInt(promotionalOffer.popup_threshold) : 1,
                    popupTime: promotionalOffer.popup_time || POPUP_TIME_DEFAULT,
                    popupType: promotionalOffer.popup_type || POPUP_TYPE_DEFAULT,
                    gymsSelected: promotionalOffer.gyms_selected,
                    tagsSelected: promotionalOffer.tags_selected
                }, () => { this._gymListRef && this._gymListRef.updateSelectedGymList() })
            })
            .catch(err => {
                ERROR_HANDLE(err);
            });
    }

    updatePromotionalOffer(promotion_id) {
        const {
            offerName,
            productName,
            title,
            popupThreshold,
            popupTime,
            popupType,
            description
        } = this.state;
        const toastId = toast("Updating Promotional offer...");
        const access_token = localStorage.getItem("access_token");
        const gymsSelectedList = this.getSelectedGyms();
        axios
            .put(
                `${API_URL}/promotional_offers/${promotion_id}`,
                {
                    offer_name: offerName,
                    product_name: productName,
                    description,
                    title,
                    popup_threshold: popupThreshold,
                    popup_time: popupTime.toLowerCase(),
                    popup_type: popupType.toLowerCase(),
                    gyms_selected: gymsSelectedList.gyms.length === 0 ? [] : gymsSelectedList.gyms,
                    tags_selected: gymsSelectedList.gymTags.length === 0 ? [] : gymsSelectedList.gymTags
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": access_token
                    }
                }
            )
            .then(res => {
                toast.dismiss(toastId);
                toast("Updated Successfully", { autoClose: 1500 });
                this.props.history.push('/gyms/PromotionalOffers/')
            })
            .catch(err => {
                toast.dismiss(toastId);
                setTimeout(() => {
                    ERROR_HANDLE(err);
                }, 500);
            });
    }

    createPromotion() {
        const {
            offerName,
            productName,
            title,
            description,
            popupThreshold,
            popupTime,
            popupType
        } = this.state;
        const toastId = toast("Creating Promotional offer...");
        const access_token = localStorage.getItem("access_token");
        const gymsSelectedList = this.getSelectedGyms();
        axios
            .post(
                `${API_URL}/promotional_offers`,
                {
                    offer_name: offerName,
                    product_name: productName,
                    description,
                    title,
                    popup_threshold: popupThreshold,
                    popup_time: popupTime.toLowerCase(),
                    popup_type: popupType.toLowerCase(),
                    gyms_selected: gymsSelectedList.gyms.length === 0 ? [] : gymsSelectedList.gyms,
                    tags_selected: gymsSelectedList.gymTags.length === 0 ? [] : gymsSelectedList.gymTags
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": access_token
                    }
                }
            )
            .then(res => {
                toast.dismiss(toastId);
                toast("Created Successfully", { autoClose: 1500 });
                this.props.history.push('/gyms/PromotionalOffers/')
            })
            .catch(err => {
                toast.dismiss(toastId);
                setTimeout(() => {
                    ERROR_HANDLE(err);
                }, 500);
            });
    }

    getSelectedGyms() {
        let gyms = []
        let gymTags = []
        this.state.gymsSelected.map((gym) => {
            gym.gym_id.toString().includes(GYM_TAG_UNIQUE_ID) ? gymTags.push(parseInt(gym.gym_id)) : gyms.push(parseInt(gym.gym_id))
        })
        return { gyms, gymTags }
    }

    getSelectedGymName() {
        const selectedGymName = this.state.gymsSelected.length > 0 ? this.state.gymsSelected[0].gym_name : ""
        const gymName = selectedGymName.length > 0 ? selectedGymName : this.state.gymsList.length > 0 ? this.state.gymsList[0].gym_name : "Gym"
        return gymName
    }

    /**
     * @description this is the props method gets handled from gym list component to avoid gyms API call every time.
     * @param gymsList - the gymsList value will receive from gym list component
     */
    updateGymsList = (gymsList) => {
        this.setState({
            gymsList
        })
    }

    /**
     * @description this is the props method gets handled from gym list component to update selected gyms.
     * @param gymsList - the selected gymsList value will receive from gym list component
     */
    updateSelectedGyms = (gymsSelected) => {
        this.setState({
            gymsSelected
        })
    }

    /**
     * @description this is the props method gets handled from close action for the preview.
     *
     */
    close() {
        this.setState({
            showPreview: false
        })
    }

    isMandatoryFieldsEntered() {
        return (this.state.title.length > 0 &&
            this.state.description.length > 0 &&
            this.state.productName.length > 0) ? true : false
    }

    incrementPopupThreshold() {
        this.setState({
            popupThreshold: this.state.popupThreshold + 1
        });
    }

    decrementPopupThreshold() {
        this.state.popupThreshold > 0 && this.setState({
            popupThreshold: this.state.popupThreshold - 1
        });
    }

    handleChangePopupTime = (event) => {
        this.setState({ popupTime: event.target.value });
    }

    handleChangePopupType = (event) => {
        this.setState({ popupType: event.target.value });
    }

    render() {
        let popUpTimeOptions = [];
        let popUpTypeOptions = [];
        Object.keys(POPUP_TIME).forEach((popUpTime, index) => {
            popUpTimeOptions.push(<option key={"popUpTime" + index} selected={this.state.popupTime.toLowerCase() == popUpTime.toLowerCase()} value={popUpTime.toLowerCase()}>{POPUP_TIME[popUpTime]}</option>);
        })
        Object.keys(POPUP_TYPE).forEach((popUpType, index) => {
            popUpTypeOptions.push(<option key={"popUpType" + index} selected={this.state.popupType.toLowerCase() == popUpType.toLowerCase()} value={popUpType.toLowerCase()}>{POPUP_TYPE[popUpType]}</option>);
        })
        return (
            <div style={style.wrapper}>
                <Box style={style.box} outline>
                    <Link style={style.linkStyle} to="/gyms/PromotionalOffers/">
                        <img style={{ width: 40, height: 40 }} src={LEFT_ARROW_IMAGE} />
                        <Button
                            style={style.promotionalOffers}
                            type="primary"
                        >
                            {PROMOTIONAL_OFFERS}
                        </Button>
                    </Link>
                    <div style={style.topPanel}>
                        <div>
                            <div style={style.selectorWrapper}>
                                <p style={style.selectorLabel}>
                                    {OFFER_NAME_TEXT} &nbsp; &nbsp;
                                </p>
                                <input
                                    type="text"
                                    value={this.state.offerName}
                                    style={style.input}
                                    onChange={e => {
                                        this.setState({
                                            offerName: e.target.value
                                        });
                                    }}
                                />
                            </div>
                            <div style={style.selectorWrapper}>
                                <p style={style.selectorLabel}>
                                    {PRODUCT_NAME_TEXT} &nbsp; &nbsp;
                                </p>
                                <input
                                    type="text"
                                    value={this.state.productName}
                                    style={style.input}
                                    onChange={e => {
                                        this.setState({
                                            productName: e.target.value
                                        });
                                    }}
                                />
                            </div>
                            <div style={style.selectorWrapper}>
                                <p style={style.selectorLabel}>
                                    {DESCRIPTION_TEXT} &nbsp; &nbsp;
                                </p>
                                <input
                                    type="text"
                                    value={this.state.description}
                                    style={style.input}
                                    onChange={e => {
                                        this.setState({
                                            description: e.target.value
                                        });
                                    }}
                                />
                            </div>
                            <div style={style.selectorWrapper}>
                                <p style={style.selectorLabel}>
                                    {TITLE_TEXT} &nbsp; &nbsp;
                                </p>
                                <textarea
                                    value={this.state.title}
                                    style={{ ...style.input, ...style.textArea }}
                                    onChange={e => {
                                        this.setState({
                                            title: e.target.value
                                        });
                                    }}
                                />
                            </div>
                            <div style={style.popupTimeContainer}>
                                <p style={{ ...style.selectorLabel, ...{ width: "auto", fontSize: 18 } }}>
                                    {POPUP_TIMING_TEXT}
                                </p>
                                <div style={style.popupSelectionContainer}>
                                    <select style={style.dropDown} onChange={this.handleChangePopupTime}>
                                        {popUpTimeOptions}
                                    </select>
                                    <div style={style.popupThresholdContainer}>
                                        <img style={{ width: 26, height: 15, marginBottom: 3 }} src={INCREMENT_ARROW_IMAGE} onClick={() => this.incrementPopupThreshold()} />
                                        <input
                                            value={this.state.popupThreshold}
                                            style={style.searchInput}
                                        />
                                        <img style={{ width: 26, height: 15, marginTop: 3 }} src={DECREMENT_ARROW_IMAGE} onClick={() => this.decrementPopupThreshold()} />
                                    </div>
                                    <select style={style.dropDown} onChange={this.handleChangePopupType}>
                                        {popUpTypeOptions}
                                    </select>
                                </div>
                            </div>
                        </div>
                        <GymList
                            ref={gymListRef => this._gymListRef = gymListRef}
                            gymsList={this.state.gymsList}
                            gymsSelected={this.state.gymsSelected ? this.state.gymsSelected : []}
                            tagsSelected={this.state.tagsSelected ? this.state.tagsSelected : []}
                            updateGymsList={(gymsList) => this.updateGymsList(gymsList)}
                            updateSelectedGyms={(gymsSelected) => this.updateSelectedGyms(gymsSelected)}
                        />
                    </div>
                    <div style={style.createButtonWrapper}>
                        <Button
                            style={style.createButton}
                            type="primary"
                            onClick={() => (this.props.location.state && this.props.location.state.promotionId) ? this.state.promotionId && this.updatePromotionalOffer(this.state.promotionId) : this.createPromotion()}
                        >
                            {(this.props.location.state && this.props.location.state.promotionId) ? UPDATE_TEXT : CREATE_TEXT}
                        </Button>
                        <Button
                            style={{ ...style.createButton, ...{ marginLeft: 40 } }}
                            type="primary"
                            onClick={() => this.isMandatoryFieldsEntered() ? this.setState({
                                showPreview: !this.state.showPreview
                            }) : alert(ALERT_TEXT)}
                        >
                            {PREVIEW_TEXT}
                        </Button>
                    </div>
                    {
                        this.state.showPreview &&
                        <PromotionalPreview
                            title={this.state.title}
                            description={this.state.description}
                            productName={this.state.productName}
                            gymName={this.getSelectedGymName()}
                            close={() => this.close()}
                        />
                    }
                </Box>
            </div>
        );
    }
}

const style = {
    wrapper: {
        display: "flex",
        justifyContent: "center",
        margin: "30px 30px 0px 30px",
        paddingBottom: 50
    },
    box: {
        width: "1200px",
        display: "flex",
        flexDirection: "column",
        padding: "40px"
    },
    topPanel: {
        display: "flex",
        justifyContent: "space-evenly",
        alignItems: "center"
    },
    createButtonWrapper: {
        width: "100%",
        justifyContent: "flex-start",
        marginTop: 20
    },
    createButton: {
        width: "300px",
        fontSize: "20px",
        marginTop: "20px"
    },
    selectorWrapper: {
        display: "flex",
        alignItems: "baseline",
        justifyContent: "center",
        flexWrap: "nowrap",
        height: 100
    },
    selectorLabel: {
        fontSize: "22px",
        color: "#444445",
        marginRight: "15px",
        width: "150px",
        textAlign: "left"
    },
    popupTimeContainer: {
        padding: 30,
        paddingTop: 20,
        marginTop: 70,
        backgroundColor: theme.color.textLightWhite,
        border: "1px solid " + theme.color.lightGrey,
        borderRadius: 10
    },
    popupSelectionContainer: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center"
    },
    popupThresholdContainer: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center"
    },
    dropDown: {
        width: 150,
        fontSize: 18,
        height: 50,
        backgroundColor: theme.color.lightGrey
    },
    searchInput: {
        backgroundColor: theme.color.lightGrey,
        borderRadius: 10,
        borderWidth: 2,
        borderStyle: "solid",
        borderColor: theme.color.lightGrey,
        fontSize: 20,
        fontFamily: theme.font.avenirHeavyOblique,
        color: theme.color.searchTextGrey,
        width: 80,
        height: 20,
        textAlign: "center"
    },
    input: {
        border: "1px solid #444445",
        borderRadius: 50,
        fontSize: "22px",
        color: "#00b4d2",
        padding: 10,
        paddingLeft: 20,
        minWidth: 300,
        textAlign: "left"
    },
    textArea: {
        resize: "none",
        height: 100,
        borderRadius: 25
    },
    promotionalOffers: {
        width: 200,
        fontSize: 17,
        borderRadius: 8,
        height: 40,
        color: theme.color.primaryBlue,
        backgroundColor: theme.color.white,
        borderWidth: 0,
        textAlign: "left"
    },
    linkStyle: {
        display: "flex",
        height: 40,
        textDecoration: "none"
    }
};

export default CreatePromotionalOffer;
